export default {
  title: 'Excepții program',
  fields: {
    status: {
      label: 'Stare',
    },
    date: {
      label: 'Dată',
    },
    description: {
      label: 'Motiv',
    },
    recurring: {
      label: 'Recurent anual',
    },
    created: {
      label: 'Creat',
      creator: 'de {{name}}',
    },
    updated: {
      label: 'Actualizat',
    },
  },
  status: {
    closed: 'Închis',
    open: 'Deschis',
    paused: 'Pauză',
  },
  date: {
    all_day: 'Toată ziua',
    paused_until_rest_of_day: 'Pauză până la sfârșitul zilei',
  },
  buttons: {
    pause_availability: '+ Pauză disponibilitate',
    close_availability: '+ Închide disponibilitate',
    amend_availability: '+ Modifică disponibilitate',
    sync_from_online_shop: 'Sincronizare din Magazin Online',
    close: 'Închide',
    delete: 'Șterge',
  },
  projects: {
    online_shop: 'Magazin Online',
    reservations: 'Rezervări',
    storefront: 'Vitrină',
  },
  error_messages: {
    delete_failed: 'Ștergerea a eșuat. Vă rugăm să încercați din nou.',
  },
  toasts: {
    sync_success: 'Sincronizat cu succes',
    sync_error: 'Sincronizarea excepțiilor de program din magazinul online a eșuat. Vă rugăm să încercați din nou.',
  },
};
